import React, { Component } from 'react';
import { connect } from 'react-redux';
import DNAAnalytics from 'dna-react-analytics/components/analytics/Analytics';
import * as analyticsGoogle from '../lib/analytics/analytics-google';
import * as analyticsKissmetrics from '../lib/analytics/analytics-kissmetrics';
import * as analytics from '../lib/analytics/analytics';

const analyticsProviders = [
	analyticsGoogle,
	analyticsKissmetrics,
];

function mapStateToProps(state) {
	return {
		analyticsData: {},
	};
}

const Analytics = (ComposedComponent, pageName) => {
	return connect(mapStateToProps, null)(DNAAnalytics(ComposedComponent, pageName, analytics, analyticsProviders));
};

export default Analytics;



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/mixins/Analytics.js